<template>
    <div
        :class="[
            'progress-bar',
            props.content.showBorder.value && 'progress-bar--border',
            props.content.innerSpacing.value && 'progress-bar--inner-spacing',
            percentage < 15 && 'progress-bar--zero',
            `progress-bar--shape-${props.content.shape.value}`,
        ]"
    >
        <div
            class="progress-bar__active"
            :style="{ width: `${percentage}%` }"
        >
            <div
                v-if="props.content.showPercentage.value"
                class="progress-bar__percentage"
            >
                {{ percentage }}%
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { componentProps } from '../../../../../mixins/component/component';
import { calculateQuizProgress } from '../../../../../mixins/utils/quiz-progress';

const store = useStore();

const props = defineProps({
    ...componentProps,
    totalQuestionsOverwrite: {
        type: Number,
        default: null,
    },
    continuousFlowLength: {
        type: Number,
        default: null,
    },
});

const totalQuestions = computed(() => {
    if (props.totalQuestionsOverwrite) return props.totalQuestionsOverwrite;
    if (props.continuousFlowLength) return props.continuousFlowLength;
    return store.state.quiz.totalFlowLength;
});

const percentage = computed(() => {
    return calculateQuizProgress(totalQuestions.value);
});

</script>

<style lang="scss" scoped>
@use 'zoe-molecule-progress-bar';

.progress-bar {
    --background: v-bind('props.content.style.background.value');
    --active-background: v-bind('props.content.style.activeBackground.value');
    --border-color: v-bind('props.content.style.borderColor.value');
    --progress-color: v-bind('props.content.style.progressColor.value');
}
</style>
